<template>
	<div class="container">
		<div class="order_detail_top" v-if="detail.order_status != 5">
			<el-steps :active="order_step" align-center simple finish-status="finish">
				<el-step
					v-for="(item, index) in stepList"
					:key="'s' + index"
					:title="item.title"
				>
				</el-step>
			</el-steps>
		</div>

		<div class="main_order_detail">
			<div class="order_status">
				<i class="el-icon-warning"></i>
				<span class="current_order_status"
					>当前订单状态: &nbsp;&nbsp;{{ order_status_name }}</span
				>
			</div>

			<div class="order_base_info">
				<div style="margin-bottom: 24px">
					<i class="el-icon-collection-tag"></i>
					<span class="top_title">基本信息</span>
				</div>

				<el-table
					border
					:data="baseInfoData"
					:cell-style="tc"
					:header-cell-style="tccolor"
					size="mini"
					style="width: 100%; margin-top: 38px"
				>
					<el-table-column
						label="自产自销订单编号"
						prop="spell_order_sn"
					></el-table-column>
					<el-table-column label="订单编号" prop="order_no"></el-table-column>
					<el-table-column
						label="下单时间"
						prop="create_order_time"
					></el-table-column>
					<el-table-column
						label="发货时间"
						prop="delivery_time"
					></el-table-column>
					<el-table-column label="签收时间" prop="sign_time"></el-table-column>
					<el-table-column
						label="取消时间"
						prop="cancel_time"
					></el-table-column>
				</el-table>
			</div>

			<div class="order_base_info">
				<div style="margin-bottom: 24px">
					<i class="el-icon-collection-tag"></i>
					<span class="top_title">收货人信息</span>
				</div>

				<el-table
					border
					:data="baseInfoData"
					:cell-style="tc"
					:header-cell-style="tccolor"
					size="mini"
					style="width: 100%; margin-top: 38px"
				>
					<el-table-column label="收货人">
						<template slot-scope="scope">
							<p v-if="scope.row.receiver_name">
								{{ scope.row.receiver_name }}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>
					<el-table-column label="联系电话">
						<template slot-scope="scope">
							<p v-if="scope.row.receiver_mobile">
								{{ scope.row.receiver_mobile }}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>

					<el-table-column label="收获地址">
						<template slot-scope="scope">
							<p v-if="scope.row.receiver_address">
								{{ scope.row.receiver_province }}.{{
									scope.row.receiver_city
								}}.{{ scope.row.receiver_area }}.{{
									scope.row.receiver_address
								}}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div class="order_base_info">
				<div style="margin-bottom: 24px">
					<i class="el-icon-collection-tag"></i>
					<span class="top_title">商品信息</span>
				</div>

				<el-table
					border
					:data="baseInfoData"
					:cell-style="tc"
					:header-cell-style="tccolor"
					size="mini"
					style="width: 100%; margin-top: 38px"
				>
					<el-table-column label="商品图片">
						<template slot-scope="scope">
							<img
								style="width: 36px; height: 36px"
								:src="scope.row.goods_img"
							/>
						</template>
					</el-table-column>
					<el-table-column label="商品名称">
						<template slot-scope="scope">
							<p v-if="scope.row.goods_name">
								{{ scope.row.goods_name }}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>

					<el-table-column label="规格属性">
						<template slot-scope="scope">
							<p v-if="scope.row.goods_mod_name">
								{{ scope.row.goods_mod_name }}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>
					<el-table-column label="数量">
						<template slot-scope="scope">
							<p v-if="scope.row.goods_num">{{ scope.row.goods_num }}件</p>
							<p v-else>---</p>
						</template>
					</el-table-column>
					<el-table-column label="价格">
						<template slot-scope="scope">
							<p v-if="scope.row.supply_price">
								供货价: ¥{{ scope.row.supply_price }}
							</p>
							<p v-else>---</p>

							<p v-if="scope.row.cost_price">
								成本价: ¥{{ scope.row.cost_price }}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>

					<el-table-column label="收益预估">
						<template slot-scope="scope">
							<p
								v-if="
									scope.row.supply_price &&
									scope.row.cost_price &&
									scope.row.goods_num
								"
							>
								¥
								{{
									(
										(Number(scope.row.supply_price) -
											Number(scope.row.cost_price)) *
										Number(scope.row.goods_num)
									).toFixed(2)
								}}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>
				</el-table>
				<div class="total_profit">
					<span style="color: #f4222d"
						>¥ {{ (Number(supply_price) * Number(goods_num)).toFixed(2) }}</span
					>
					<span>合计:</span>
				</div>
			</div>

			<div class="order_base_info">
				<div style="margin-bottom: 24px">
					<i class="el-icon-collection-tag"></i>
					<span class="top_title">物流信息</span>
				</div>

				<el-table
					border
					:data="baseInfoData"
					:cell-style="tc"
					:header-cell-style="tccolor"
					size="mini"
					style="width: 100%; margin-top: 38px"
				>
					<el-table-column label="物流公司">
						<template slot-scope="scope">
							<p v-if="scope.row.logistics_company">
								{{ scope.row.logistics_company }}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>
					<el-table-column label="物流单号">
						<template slot-scope="scope">
							<p v-if="scope.row.logistics_number">
								{{ scope.row.logistics_number }}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>
					<!-- <el-table-column label="物流费用"> -->
					<!-- <template slot-scope="scope">
							<p v-if="scope.row.supplier_name">
								{{ scope.row.supplier_name }}
							</p>
							<p v-else>---</p>
						</template> -->
					<!-- </el-table-column> -->
					<el-table-column label="发货时间">
						<template slot-scope="scope">
							<p v-if="scope.row.delivery_time">
								{{ scope.row.delivery_time }}
							</p>
							<p v-else>---</p>
						</template>
					</el-table-column>
					<!-- <el-table-column label="物流状态"> -->
					<!-- <template slot-scope="scope">
							<p v-if="scope.row.attribute">
								{{ scope.row.attribute }}
							</p>
							<p v-else>---</p>
						</template> -->
					<!-- </el-table-column> -->
				</el-table>
			</div>
		</div>
	</div>
</template>
<script>
import { orderSpellDetailInfo, expressCompanyList } from '@/api/order'

export default {
	data() {
		return {
			orderId: '',
			order_status_name: '',
			goods_num: 0,
			cost_price: '',
			supply_price: '',
			detail: {},
			order_express_detail: {},
			wuliuData: {},
			baseInfoData: [],
			showTrackDialog: false,
			remark: '',
			order_step: 3,
			stepList: [
				{ title: '提交订单' },
				{ title: '支付订单' },
				{ title: '平台发货' },
				{ title: '物流配送' },
				{ title: '完成订单' },
			],
		}
	},
	activated() {
		this.orderId = this.$route.query.orderId
		if (this.orderId) {
			this.orderDetailInfoData()
		}
	},
	methods: {
		//确认发货
		certainPushWoods() {
			this.showWuliuOrChange = true
		},
		//获取订单详情
		async orderDetailInfoData() {
			let res = await orderSpellDetailInfo(this.orderId)

			this.baseInfoData = []
			this.userInfoData = []
			this.goodsInfoData = []
			this.operateData = []
			this.wuliuForm = {}
			this.wuliuData = []
			// 物流轨迹数据
			this.activities = []
			this.detail = res

			if (res.order_status == 1) {
				this.order_step = 2
			} else if (res.order_status == 2) {
				this.order_step = 4
			} else if (res.order_status == 3) {
				this.order_step = 5
			} else if (res.order_status == 4) {
				this.order_step = 1
			} else {
				this.order_step = 5
			}
			this.baseInfoData.push({
				id: res.id,
				order_no: res.order_no,
				spell_order_id: res.spell_order_id,
				spell_order_sn: res.spell_order_sn,
				goods_no: res.goods_no,
				goods_name: res.goods_name,
				goods_img: res.goods_img,
				goods_mod_name: res.goods_mod_name,
				goods_num: res.goods_num,
				receiver_name: res.receiver_name,
				receiver_mobile: res.receiver_mobile,
				receiver_province: res.receiver_province,
				receiver_city: res.receiver_city,
				receiver_area: res.receiver_area,
				receiver_address: res.receiver_address,
				logistics_company: res.logistics_company,
				logistics_number: res.logistics_number,
				remark: res.remark,
				order_status: res.order_status,
				order_status_name: res.order_status_name,
				cost_price: res.cost_price,
				supply_price: res.supply_price,
				create_order_time: res.create_order_time,
				delivery_time: res.delivery_time ? res.delivery_time : '',
				sign_time: res.sign_time ? res.sign_time : '',
				cancel_time: res.cancel_time ? res.cancel_time : '',
			})
			this.order_status_name = res.order_status_name
			this.cost_price = res.cost_price
			this.supply_price = res.supply_price
			this.goods_num = res.goods_num

			console.log(this.baseInfoData)
		},
		createRemark() {
			this.remark = ''
			this.showCreateRemark = true
		},

		//跟踪物流轨迹
		trackWuliuInfo() {
			this.showTrackDialog = true
			this.expressLogisticsTraceData()
		},

		//获取物流公司列表
		async expressCompanyListData() {
			let res = await expressCompanyList()
			this.expressCode = []
			for (let key in res) {
				let obj = {}
				obj['code'] = key
				obj['value'] = res[key]
				this.expressCode.push(obj)
			}
			console.log(this.expressCode)
		},

		cancelApply() {
			this.showApplyOrder = false
		},
		tc() {
			return 'text-align:center;'
		},
		tccolor() {
			return 'text-align:center;background-color:#f5f5f5; font-size:14px;font-weight:500;color:rgb(102,102,102);'
		},
	},
}
</script>
<style lang="scss" scoped>
.container {
	padding-bottom: 20px;
	.order_detail_top {
		background-color: rgb(240, 242, 245);
		padding: 20px;
		height: 120px;
	}
	.main_order_detail {
		margin: 25px 12px;
		border: 1px solid rgb(228, 228, 228);
		padding-bottom: 20px;
		.order_status {
			background-color: rgb(243, 243, 243);
			height: 72px;
			line-height: 72px;
			i {
				color: #f4222d;
				font-size: 16px;
				float: left;
				margin-top: 27px;
				margin-left: 24px;
			}
			.current_order_status {
				float: left;
				font-size: 18px;
				color: rgb(237, 103, 102);
				font-weight: 500;
			}
		}
		.order_base_info {
			margin: 36px 20px 0 20px;
			overflow: hidden;
			i {
				color: rgb(51, 51, 51);
				float: left;
				margin-top: 4px;
				font-size: 20px;
				font-weight: 500;
			}
			.top_title {
				float: left;
				font-weight: 500;
				font-size: 18px;
			}
		}
	}
	.total_profit {
		background-color: rgb(240, 242, 245);
		height: 42px;
		line-height: 42px;
		span {
			float: right;
			margin-right: 12px;
			font-weight: 500;
			font-size: 16px;
		}
	}
	.el-steps {
		height: 72px;
	}

	.after_table {
		border: 1px solid rgb(228, 228, 228);
		margin: 20px 28px;
		border-collapse: collapse;
		width: 90%;
		.pic_tab {
			height: 60px;
		}
		.refund_reason {
			height: 100px;
		}
		tr {
			height: 48px;
			td {
				border: 1px solid rgb(228, 228, 228);
				padding: 10px;
				font-size: 13px;
			}
			td:first-child {
				background-color: rgb(249, 250, 252);
				width: 160px;
				text-align: right;
				padding-right: 24px;
				font-weight: 500;
			}
			td:last-child {
				text-align: left;
				padding-left: 24px;
			}
		}
		tr:last-child {
			height: 72px;
		}
	}

	.el-timeline-item {
		text-align: left;
	}

	.timeline-content {
		color: #999;
		font-size: 12px;
		margin-bottom: 4px;
	}
	.radio_label {
		font-size: 12px;
	}
}
</style>
